export default "__VITE_ASSET__CCudiF$O__"